import $ from 'jquery';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default class Infographic {
    constructor() {
        if($('.js-image-slider').length) {
            const $infographicSlider = $('.js-image-slider');

            $infographicSlider.each(function() {
                const $slider = $(this)[0];

                const infographicSlider = new Swiper($slider, {
                    modules: [
                        Pagination
                    ],
                    pagination: {
                        clickable: true,
                        el: '.swiper-pagination'
                    },
                    slidesPerView: 1
                });
            });
        };
    };
};
